import React from "react";

const LoadingPage = () => {
  return (
    <div className="loading-page">
      <img
        src={process.env.PUBLIC_URL + "/images/btc-loading.gif"}
        alt="Loading..."
        className="loading-image"
      />
    </div>
  );
};

export default LoadingPage;
